import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ANALYTICS_EVENT } from '@/common/constants/analyticsEvents';
import ProfileDetailsModal from '@/pages/customer/home/components/profileDetailsModal/ProfileDetailsModal';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import { useAnalytics } from '@/common/contexts/AnalyticsContext';
import { PagePad } from '@/common/styles/shared.styles';
import MySoftiesGrid from './components/MySoftiesGrid/MySoftiesGrid';
import MySoftiesHeading from './components/MySoftiesHeading/MySoftiesHeading';
import { useMySofties } from './hooks/useMySofties';
import { MySoftiesView } from './MySofties.styles';

const MySofties = () => {
	const navigate = useNavigate();
	const t = useLanguageData('mySofties');
	const { trackAnalytics } = useAnalytics();
	const { persons, selectedProfile, setSelectedProfile, isLoading } = useMySofties();

	useEffect(() => {
		trackAnalytics(ANALYTICS_EVENT.MY_SOFTIES.OPEN);
	}, []);

	const handleCloseProfile = () => {
		setSelectedProfile(undefined);
	};

	const handleCreateSoftie = () => {
		trackAnalytics(ANALYTICS_EVENT.MY_SOFTIES.CREATE);
		navigate('/studio');
	};

	const handleSelectProfile = (profile) => {
		setSelectedProfile(profile);
	};

	return (
		<>
			{selectedProfile && (
				<ProfileDetailsModal
					profile={selectedProfile}
					onClose={handleCloseProfile}
					chatStartEvent={ANALYTICS_EVENT.MY_SOFTIES.OPEN_CHAT}
					analyticsSource="my_softies"
				/>
			)}
			<MySoftiesView id="mineView" data-view="mine">
				<PagePad>
					<MySoftiesHeading
						titlePrefix={t.titlePrefix}
						titleHighlight={t.titleHighlight}
					/>
					<MySoftiesGrid
						persons={persons}
						isLoading={isLoading}
						createLabel={t.createSoftie}
						onCreateSoftie={handleCreateSoftie}
						onSelectProfile={handleSelectProfile}
					/>
				</PagePad>
			</MySoftiesView>
		</>
	);
};

export default MySofties;
